const NAME = "PERFORMANCE_ANALYTICS_TALENT";

export default NAME;